import { fetchData } from "@redux/slices/functionals/request/requestActions";
import { CElementType, IElementType } from "@ts/ui-models";

export const getElementType = async (
    dispatch,
    id: string | string[] | undefined
): Promise<IElementType | IElementType[] | null> => {
    if (!id) return null;
    const result = await dispatch(
        fetchData({
            key: 'getElementType',
            url: `/api/itemTypes`,
            dataBody: { where: { id: id } },
            withoutCancel: true,
        })
    );
    if (result?.payload?.data) {
        return Array.isArray(id) ? result.payload.data.rows : result.payload.data.rows[0];
    }
    return null;
};

export const getElementTypeById = async (dispatch, id: string): Promise<CElementType | null> => {
    const result = await dispatch(
        fetchData({
            url: `/api/v2/itemType/${id}`,
        })
    );
    if (result?.payload?.data) {
        return new CElementType(result.payload.data);
    }
    return null;
};